import { Pipe, PipeTransform } from '@angular/core';
import { PollTypeEnum } from '../../utils/enums/poll-type.enum';


@Pipe({
    name: 'pollTypeDescription',
    standalone: true,
})
export class PollTypeDescriptionPipe implements PipeTransform {
    transform(type: PollTypeEnum | number): string {
        return type === PollTypeEnum.Satisfaction || type === 0
            ? 'Satisfação'
            : 'Reserva de pratos';
    }
}